import ptBR from './pt-br.json';

export default {
    "pt-br": ptBR
};